module.exports = __webpack_public_path__ + "img/logo2_1.88685aa5.png";